export default {
  contract: state => state.contract
}
